<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div
  *ngIf="!isMobileDevice()"
  fxLayout="column"
  fxLayoutAlign="center center"
  fxLayoutGap="10px"
  class="nvs-margin-custom nvs-total"
  (keyup.enter)="submit()"
>
  <div fxLayoutAlign="start start" class="nvs-width-25">
    <mat-icon
      class="place-self-center ws-cursor-pointer notranslate"
      (click)="backToHome()"
      svgIcon="arrow_back"
    >
    </mat-icon>
    <img
      (click)="backToHome()"
      class="whiteshop-logo ws-cursor-pointer"
      [src]="whiteShopIcon"
      alt="whiteShopIcon"
    />
  </div>
  <div class="nvs-text-bold nvs-width-25" fxLAyoutAlign="start start">
    Enter your email address to register
  </div>
  <div
    class="nvs-text-normal nvc-font-weight-normal nvs-color-grey nvs-width-25"
  >
    We suggest using your
    <span class="nvs-text-black">official email address</span>
  </div>
  <div
    fxLayout="column"
    fxLAyoutAlign="start start"
    fxLayoutGap="10px"
    [formGroup]="registerForm"
  >
    <div class="nvs-width-26 nvc-position-relative">
      <mat-form-field
        appearance="outline"
        class="sc-mat-form-input nvc-width-hundred"
        hideRequiredMarker="true"
      >
        <mat-label class="sc-input-label">Email*</mat-label>
        <input
          matInput
          id="email"
          type="email"
          placeholder=""
          class=""
          formControlName="username"
          (blur)="
            !registerForm.controls['username'].dirty
              ? registerForm.controls['username'].markAsUntouched()
              : ''
          "
        />
      </mat-form-field>
    </div>
    <div
      *ngIf="
        !validUserName() &&
        registerForm.controls['username'].dirty &&
        registerForm.controls['username'].touched
      "
    >
      <small id="emailPhoneError" class="nvc-red">
        Enter a valid email address
      </small>
    </div>
    <div class="nvs-width-26 nvs-position-relative">
      <mat-form-field
        class="sc-mat-form-input nvc-width-hundred"
        appearance="outline"
        hideRequiredMarker="true"
      >
        <mat-label class="sc-input-label">Password*</mat-label>
        <input
          matInput
          id="new-password"
          fxFlex="90"
          [type]="passwordType"
          placeholder=""
          class="nvc-input-tag"
          formControlName="password"
        />
        <mat-icon
          matSuffix
          [svgIcon]="passwordVisibility ? 'eyeIcon' : 'eyeSlashIcon'"
          class="nvc-eye ws-cursor-pointer"
          (click)="togglePasswordVisibility()"
        >
        </mat-icon>
      </mat-form-field>
    </div>
    <div id="passwordLength" class="nvs-margin-0 nvs-text-blue">
      Minimum 8 characters required
    </div>
  </div>
  <div class="nvs-width-26">
    <button
      class="button-shadow-focus nvs-submit-button nvc-font-weight-normal ws-cursor-pointer nvc-uppercase"
      [disabled]="!validLead()"
      (click)="registerStore()"
      [ngClass]="{ 'nvc-disabled ws-no-cursor-pointer': !validLead() }"
    >
      CONTINUE
    </button>
  </div>
  <div class="nvs-text-small nvc-font-weight-normal nvs-width-25">
    Already have an account?
    <button
      class="border-focus-blue button-clear nvs-text-black-600 ws-cursor-pointer"
      (click)="goToLogin()"
    >
      Login
    </button>
  </div>
  <div
    class="nvs-text-terms nvc-position-absolute nvc-font-weight-normal nvs-width-25"
  >
    By providing your email you are agreeing to our
    <span>Terms & Conditions</span>
  </div>
</div>

<div
  *ngIf="isMobileDevice()"
  fxLayout="column"
  fxLayoutAlign="space-between center"
  class="nvs-margin-custom nvs-total"
  (keyup.enter)="submit()"
>
  <div
    fxLayout="column"
    fxLayoutAlign="space-between center"
    fxLayoutGap="3rem"
  >
    <div fxLayoutAlign="start start" class="nvc-width-hundred">
      <mat-icon
        class="place-self-center ws-cursor-pointer notranslate"
        (click)="backToHome()"
        svgIcon="arrow_back"
      >
      </mat-icon>
      <img
        (click)="backToHome()"
        class="whiteshop-logo ws-cursor-pointer"
        [src]="whiteShopIcon"
        alt="whiteShopIcon"
      />
    </div>
    <div
      fxLayout="column"
      fxLAyoutAlign="space-between center"
      fxLayoutGap="20px"
    >
      <div class="nvs-text-bold nvc-width-hundred nvc-margin-bottom-40">
        Enter your email address to register
      </div>

      <div
        class="nvs-text-normal nvc-font-weight-normal nvc-margin-bottom-30 nvs-color-grey nvc-width-hundred"
      >
        We suggest using your
        <span class="nvs-text-black">official email address</span>
      </div>
      <div
        fxLayout="column"
        fxLayoutAlign="space-between center"
        fxLayoutGap="2rem"
        [formGroup]="registerForm"
      >
        <div class="nvc-width-hundred">
          <div class="nvc-width-hundred nvc-margin-bottom-20">
            <mat-form-field
              class="sc-mat-form-input nvc-width-hundred"
              appearance="outline"
              hideRequiredMarker="true"
            >
              <mat-label class="sc-input-label">Email*</mat-label>
              <input
                matInput
                id="email"
                type="email"
                placeholder=""
                class=""
                formControlName="username"
                (blur)="
                  !registerForm.controls['username'].dirty
                    ? registerForm.controls['username'].markAsUntouched()
                    : ''
                "
              />
            </mat-form-field>
          </div>
          <div
            *ngIf="
              !validUserName() &&
              registerForm.controls['username'].touched &&
              registerForm.controls['username'].dirty
            "
            class="nvc-red nvc-margin-error"
          >
            <small id="emailPhoneError"> Enter a valid email address </small>
          </div>
          <div class="nvc-width-hundred nvc-position-relative">
            <mat-form-field
              appearance="outline"
              class="sc-mat-form-input nvc-width-hundred"
              hideRequiredMarker="true"
            >
              <mat-label class="sc-input-label">Password*</mat-label>
              <input
                matInput
                id="password"
                [type]="passwordType"
                placeholder=""
                class=""
                formControlName="password"
                #passwordField
              />
              <mat-icon
                matSuffix
                [svgIcon]="passwordVisibility ? 'eyeIcon' : 'eyeSlashIcon'"
                class="nvc-eye ws-cursor-pointer"
                (click)="togglePasswordVisibility()"
              >
              </mat-icon>
            </mat-form-field>
          </div>
          <div id="passwordLength" class="nvs-margin-0 nvs-text-blue">
            Minimum 8 characters required
          </div>
        </div>
        <div fxLayout="column" fxLayoutGap="10px" class="nvc-width-hundred">
          <div>
            <button
              class="button-shadow-focus nvs-submit-button nvc-font-weight-normal ws-cursor-pointer nvc-camelCase"
              [disabled]="!validLead()"
              (click)="registerStore()"
              [ngClass]="{ 'nvc-disabled ws-no-cursor-pointer': !validLead() }"
            >
              CONTINUE
            </button>
          </div>
          <div
            fxLayout="row"
            fxLayoutGap="5px"
            class="nvs-text-small nvc-font-weight-normal nvs-color-grey"
          >
            <span> Already have an account? </span>
            <span
              class="border-focus-blue nvs-text-black-600 ws-cursor-pointer"
              (click)="goToLogin()"
            >
              Login
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="nvs-text-terms nvc-position-relative nvc-font-weight-normal">
    By providing your email you are agreeing to our
    <span>Terms & Conditions</span>
  </div>
</div>

<!-- <div
  fxLayout="column"
  fxLayoutAlign="start center"
  class="nvc-total nvc-mobile-margin"
  [formGroup]="registerForm"
  fxLayoutGap="10px"
  (keyup.enter)="submit()"
>
  <div fxLayout fxLayoutAlign="end" class="nvs-back-width">
    <mat-icon
      class="ws-cursor-pointer"
      (click)="backToHome()"
      style="margin-right: 0.3rem; margin-top: 1rem"
      >close</mat-icon
    >
  </div>
  <div fxLayout class="nvc-input-div">
    <div class="register-text" fxFlex="100" fxLayoutAlign="center center">
      {{ data.type === "B2C" ? "Create Account" : "Register your store" }}
    </div>
  </div>
  <div class="nvc-input-div" *ngIf="data.type === 'B2C'">
    <div class="nvc-input" fxLayout="row" fxLayoutAlign="start center">
      <input
        id="displayname"
        type="text"
        placeholder="Display Name"
        class="nvc-input-tag"
        formControlName="displayName"
        matInput
        required
        (blur)="!registerForm.controls['displayName'].dirty ? registerForm.controls['displayName'].markAsUntouched() : ''"
      />
    </div>
    <div fxLayout>
      <div
        *ngIf="
          !validDisplayName() && registerForm.controls['displayName'].touched && registerForm.controls['displayName'].dirty
        "
      >
        <small id="dispNameError" class="nvc-red">* Enter display name</small>
      </div>
    </div>
  </div>
  <div class="nvc-input-div">
    <div class="nvc-input" fxLayout="row" fxLayoutAlign="start center">
      <input
        id="emailorphone"
        type="text"
        placeholder="Email ID or phone Number"
        class="nvc-input-tag"
        formControlName="username"
        required
        (blur)="!registerForm.controls['username'].dirty ? registerForm.controls['username'].markAsUntouched() : ''"
      />
    </div>
    <div fxLayout>
      <div *ngIf="!validUserName() && registerForm.controls['username'].touched && registerForm.controls['username'].dirty">
        <small id="emailPhoneError" class="nvc-red"
          >* Enter Email Id or phone Number</small
        >
      </div>
    </div>
  </div>
  <div class="nvc-input-div">
    <button
      id="buttonReg"
      class="nvc-button-register ws-cursor-pointer"
      (click)="registerStore()"
      [disabled]="!validLead()"
      [ngClass]="{ 'nvc-disabled ws-no-cursor-pointer': !validLead() }"
    >
      <b>
        {{ data.type === "B2C" ? "Create Account" : "Register your store" }}
      </b>
    </button>
  </div>
  <div class="nvs-registerstore-footer ws-cursor-pointer" (click)="goToLogin()">
    Are you already a member?
  </div>
</div> -->
